/* eslint-disable no-unused-vars */
export enum IconType {
  BUILDING = 'building',
  CHECK = 'check',
  CHECK_CIRCLE = 'checkCircle',
  CLOSE = 'close',
  DOWN = 'down',
  ELEVATOR = 'elevator',
  LEFT = 'left',
  RIGHT = 'right',
  UP = 'up',
  SEARCH = 'search',
  START_INDICATOR = 'startIndicator',
  HAMBURGER = 'hamburger',
  HAMBURGER_OPEN = 'hamburgerOpen',
  INFO = 'info',
  LOCATION = 'location',
  LOCATION_OPEN = 'locationOpen',
  MAP_LOCATION = 'mapLocation',
  NO_RESULTS = 'noResults',
  PIN = 'pin',
  PIN_ACTIVE = 'pinActive',
  PROGRESS_ACTIVITY = 'progressActivity',
  YOU_ARE_HERE = 'youAreHere',
  CURRENT_LOCATION = 'currentLocation',
  MORE_VERT = 'moreVert',
  CAMPUS_LOCATIONS = 'campusLocations',
  SEND_MOBILE = 'send_mobile',
  PRINT = 'print',
  SEND_EMAIL = 'send_email',
  CAR = 'car',
  WALKING = 'walking',
}
